export default "__VITE_ASSET__CtT4KKu8__"